import { render } from "./Demo1.vue?vue&type=template&id=43d18914&ts=true"
import script from "./Demo1.vue?vue&type=script&lang=ts"
export * from "./Demo1.vue?vue&type=script&lang=ts"

import exportComponent from "/home/starkoms/webapps/front-comm-starkoms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__